export function getActiveMarker(state) {
    return state.active_marker;
}

export function getFlyToLocation(state) {
    return state.fly_to_location;
}